import { render } from "./PhotographerVTwo.vue?vue&type=template&id=07b6b5f1&scoped=true"
import script from "./PhotographerVTwo.vue?vue&type=script&lang=js"
export * from "./PhotographerVTwo.vue?vue&type=script&lang=js"

import "./PhotographerVTwo.vue?vue&type=style&index=0&id=07b6b5f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b6b5f1"]])

export default __exports__